import { useSelector } from 'react-redux'
import { PRODUCTS, UI, UNITS, BUSINESSES, BRANCHES, DEPARTMENTS, STORAGES, GOODS_NAME, SUPPLIERS } from '../constants/GlobalConstant';


const I18N = ({type, path, value, def, replace, property}) => {

  if(!def) {
    def = "";
  }

  let i18n = useSelector( (state) => state.i18n);
  let locale = useSelector( (state) => state.auth.locale );
  locale = !locale ? 'zh-hk' : locale;

  i18n = JSON.parse(JSON.stringify(i18n));

  if(!i18n) {
    return def;
  }

  const getGoodsName = (i18n, path, value) => {
    if(i18n && i18n[locale] && i18n[locale].products) {
      let filter = i18n[locale].products.filter( (obj) => obj[path] === value )[0];
      if(filter) {
        return filter[GOODS_NAME];
      }
    }
  }

  // UI
  if(type === "UI" && i18n[locale] && i18n[locale].ui && i18n[locale].ui.filter) {
    let filter = i18n[locale].ui.filter( (obj) => obj.name === path )[0];
    if(filter) {
      if(typeof replace === "object") {
        for (let key in replace) {

          let _replace = replace[key];
          
          if(key === "GOODSNAME" && typeof replace[key] === "object") {
            let goodsName  = getGoodsName(i18n, "GoodsId", replace[key].goodsId);
            if(goodsName) {
              _replace = goodsName;
            } else {
              _replace = replace[key].goodsName;
            }
          }
          
          filter.translation = filter.translation.replace(`{${key}}`, _replace);
        }
      }
      return filter.translation;   
    }
  }

  // UNIT
  if(type === UNITS && i18n[locale] && i18n[locale][UNITS] && i18n[locale][UNITS].filter) {
    let filter = i18n[locale][UNITS].filter( (obj) => obj.unitName === value )[0];
    if(filter) {
      return filter.translation;
    }
  }
  
  // PRODUCTS
  if(type === PRODUCTS) {
    let product = getGoodsName(i18n, "GoodsId", value);
    if(product) {
      return product;
    }
  }

  const getBusinessData = (value) => {
    return i18n[locale][BUSINESSES].filter( (obj) => obj.BusinessId === value )[0];
  }

  const getBranchData = () => {
    let business = getBusinessData(value.businessId);
    if(business && business[BRANCHES] && business[BRANCHES].filter) {
      return business[BRANCHES].filter( (obj) => obj.BranchId === value.branchId )[0];
    }
  }

  const getDepartmentData = () => {
    let business = getBusinessData(value.businessId);
    if(business && business[BRANCHES] && business[BRANCHES].filter) {
      let branch = business[BRANCHES].filter( (obj) => obj.BranchId === value.branchId )[0];
      if(branch && branch[DEPARTMENTS] && branch[DEPARTMENTS].filter) {
        return branch[DEPARTMENTS].filter( (obj) => obj.DepId === value.depId )[0];
      }
    }
  }

  const getStorageData = () => {
    let business = getBusinessData(value.businessId);
    if(business && business[BRANCHES] && business[BRANCHES].filter) {
      let branch = business[BRANCHES].filter( (obj) => obj.BranchId === value.branchId )[0];
      if(branch && branch[STORAGES] && branch[STORAGES].filter) {
        return branch[STORAGES].filter( (obj) => obj.StorageId === value.storageId )[0];
      }
    }
  }

  // BUSINESSES
  if(type === BUSINESSES && i18n[locale] && i18n[locale][BUSINESSES] && i18n[locale][BUSINESSES].filter) {
    let business = getBusinessData(value);
    if(business && business[property]) {
      return business[property];
    }
  }

  // BRANCHES
  if(type === BRANCHES && i18n[locale] && i18n[locale][BUSINESSES] && i18n[locale][BUSINESSES].filter) {
    let branch = getBranchData();
    if(branch && branch[property]) {
      return branch[property];
    }
  }

  // DEPARTMENTS
  if(type === DEPARTMENTS && i18n[locale] && i18n[locale][BUSINESSES] && i18n[locale][BUSINESSES].filter) {
    let department = getDepartmentData();
    if(department && department[property]) {
      return department[property];
    }
  }

  // STORAGES
  if(type === STORAGES && i18n[locale] && i18n[locale][BUSINESSES] && i18n[locale][BUSINESSES].filter) {
    let storage = getStorageData();
    if(storage && storage[property]) {
      return storage[property];
    }
  }

  // SUPPLIERS
  if(type === SUPPLIERS && i18n[locale] && i18n[locale][SUPPLIERS] && i18n[locale][SUPPLIERS].filter) {
    let supplier = i18n[locale][SUPPLIERS].filter( (obj) => obj.SupplierId === value )[0];

    if(supplier && supplier[property]) {
      return supplier[property];
    }
  }

  return (
    def
  );

}

export default I18N;